/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// ============================================
// 医療機関コード検証
// ============================================

(function() {
  'use strict';

  // GAS WebアプリのURL
  var CLINIC_CODE_API_URL = 'https://script.google.com/macros/s/AKfycbzIKTyoHcdASLpL3SPq6uEDDEBl3AoUKxGusQUdhBrnS4-uvdLB6PHJehRsyf7NQRT-wg/exec';

  // 登録フォームの初期化
  function initRegisterForm() {
    console.log('initRegisterForm called');
    var form = document.querySelector('form[action*="/account"]');
    var codeInput = document.getElementById('IntroductionCode');
    var submitBtn = form ? form.querySelector('input[type="submit"]') : null;

    console.log('form:', form);
    console.log('codeInput:', codeInput);
    console.log('submitBtn:', submitBtn);

    if (!form || !codeInput || !submitBtn) {
      console.log('Required elements not found, exiting');
      return;
    }
    console.log('All elements found, initializing...');

    // 送信ボタンを最初から無効化
    submitBtn.disabled = true;
    submitBtn.style.opacity = '0.5';
    submitBtn.style.cursor = 'not-allowed';

    // 検証結果表示用の要素を追加
    var feedbackEl = document.createElement('div');
    feedbackEl.id = 'code-feedback';
    feedbackEl.style.cssText = 'margin-top: 8px; font-size: 14px;';
    codeInput.parentNode.insertBefore(feedbackEl, codeInput.nextSibling);

    // ボタンの有効/無効を切り替える関数
    function setSubmitEnabled(enabled) {
      submitBtn.disabled = !enabled;
      submitBtn.style.opacity = enabled ? '1' : '0.5';
      submitBtn.style.cursor = enabled ? 'pointer' : 'not-allowed';
    }

    // 入力時にリアルタイム検証（debounce）
    var debounceTimer;
    codeInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var code = this.value.trim();

      // コードが変更されたらボタンを無効化
      setSubmitEnabled(false);
      codeInput.dataset.verified = 'false';

      if (code.length < 3) {
        feedbackEl.textContent = '';
        return;
      }

      debounceTimer = setTimeout(function() {
        verifyClinicCode(code, feedbackEl, setSubmitEnabled);
      }, 500);
    });

    // フォーム送信時の検証（二重チェック）
    form.addEventListener('submit', function(e) {
      if (codeInput.dataset.verified !== 'true') {
        e.preventDefault();
        showFeedback(feedbackEl, 'error', '有効な紹介コードを入力してください');
        codeInput.focus();
      }
    });
  }

  // コード検証（リアルタイム表示用）
  function verifyClinicCode(code, feedbackEl, setSubmitEnabled) {
    if (!CLINIC_CODE_API_URL) {
      showFeedback(feedbackEl, 'info', 'API未設定');
      return;
    }

    showFeedback(feedbackEl, 'loading', '検証中...');

    verifyClinicCodeAsync(code)
      .then(function(result) {
        console.log('API result:', result);
        if (result.valid) {
          showFeedback(feedbackEl, 'success', '✓ ' + result.clinicName);
          document.getElementById('IntroductionCode').dataset.verified = 'true';
          setSubmitEnabled(true);
        } else {
          showFeedback(feedbackEl, 'error', result.error || '無効なコードです');
          document.getElementById('IntroductionCode').dataset.verified = 'false';
          setSubmitEnabled(false);
        }
      })
      .catch(function(err) {
        console.error('API error:', err);
        showFeedback(feedbackEl, 'error', '通信エラー');
        setSubmitEnabled(false);
      });
  }

  // API呼び出し（Promise）
  function verifyClinicCodeAsync(code) {
    var url = CLINIC_CODE_API_URL + '?action=verify&code=' + encodeURIComponent(code);
    console.log('Calling API:', url);

    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      redirect: 'follow'
    })
      .then(function(response) {
        console.log('Response status:', response.status);
        if (!response.ok) {
          throw new Error('HTTP error: ' + response.status);
        }
        return response.json();
      });
  }

  // フィードバック表示
  function showFeedback(el, type, message) {
    var colors = {
      success: '#2d5a4a',
      error: '#c0392b',
      loading: '#7f8c8d',
      info: '#3498db'
    };

    el.textContent = message;
    el.style.color = colors[type] || '#333';
  }

  // DOM読み込み後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRegisterForm);
  } else {
    initRegisterForm();
  }
})();
